import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { company } from '../data/site';

const sections = [
  {
    title: 'Agreement to These Terms',
    body: [
      `These Terms of Use govern your access to and use of ${company.domain} (the "Website"), operated by ${company.legalName} ("we", "us" or "our"), ${company.address}.`,
      'By accessing or using the Website, you agree to these Terms. If you do not agree, please do not use the Website.',
    ],
  },
  {
    title: 'Our Products',
    body: [
      'The Website provides information about Market Fusion Innovations and its products, including PDF Flows and InstruKit. The download and use of any of our products is governed by the terms, licence agreement and privacy policy published for that product on its own website. In the event of a conflict, the product-specific terms apply to the product.',
    ],
  },
  {
    title: 'Acceptable Use',
    body: [
      'You agree to use the Website lawfully and not to:',
      [
        'Breach any applicable local, national or international law or regulation',
        'Attempt to gain unauthorised access to the Website, its servers or any connected systems',
        'Introduce viruses, malware or other harmful material',
        'Interfere with or disrupt the integrity or performance of the Website',
        'Scrape, copy or reproduce Website content for commercial purposes without our written permission',
      ],
    ],
  },
  {
    title: 'Intellectual Property',
    body: [
      `All content on the Website — including text, graphics, logos, product names, icons and design — is owned by or licensed to ${company.legalName} and is protected by intellectual property laws. "Market Fusion Innovations", "PDF Flows" and "InstruKit" are names used by us to identify our company and products.`,
      'You may view and print pages of the Website for your personal, non-commercial use. No other rights are granted.',
    ],
  },
  {
    title: 'Third-Party Links',
    body: [
      'The Website contains links to other websites, including our product websites and third-party services. We are not responsible for the content, policies or practices of websites we do not operate, and links do not imply endorsement.',
    ],
  },
  {
    title: 'Disclaimer',
    body: [
      'The Website is provided on an "as is" and "as available" basis. While we strive to keep information accurate and current, we make no warranties, express or implied, regarding the completeness, accuracy, reliability or availability of the Website or its content.',
    ],
  },
  {
    title: 'Limitation of Liability',
    body: [
      `To the maximum extent permitted by law, ${company.legalName} and its officers, employees and partners shall not be liable for any indirect, incidental, special, consequential or punitive damages, or any loss of data, profits or revenue, arising from your use of or inability to use the Website. Nothing in these Terms limits liability that cannot be limited under applicable law.`,
    ],
  },
  {
    title: 'Indemnification',
    body: [
      'You agree to indemnify and hold us harmless from any claims, losses or expenses, including reasonable legal fees, arising from your breach of these Terms or misuse of the Website.',
    ],
  },
  {
    title: 'Changes to These Terms',
    body: [
      'We may revise these Terms at any time by publishing an updated version on this page. Continued use of the Website after changes take effect constitutes acceptance of the revised Terms.',
    ],
  },
  {
    title: 'Governing Law and Jurisdiction',
    body: [
      'These Terms are governed by the laws of Ukraine. Any dispute arising out of or in connection with these Terms shall be subject to the jurisdiction of the competent courts of Kyiv, Ukraine, without prejudice to any mandatory consumer protection rights you may have in your country of residence.',
    ],
  },
  {
    title: 'Contact Us',
    body: [
      'Questions about these Terms can be sent to:',
      [`By email: ${company.email}`, `By post: ${company.legalName}, ${company.address}`],
    ],
  },
];

export default function Terms() {
  return <LegalLayout title="Terms of Use" updated="October 2026" sections={sections} />;
}
